import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserCourseModule } from './user-course/user-course.module';
import { UserDashboardModule } from './user-dashboard/user-dashboard.module';

// Pages Globaly required Components - Optional
import { pgTabsModule } from './../@hornbillfx/components/tabs/tabs.module';
import { pgSwitchModule } from './../@hornbillfx/components/switch/switch.module';
import { ProgressModule } from './../@hornbillfx/components/progress/progress.module';
import { FilterService } from '../services/filter.service';
import { UserModuleRoutes, userComponents } from './user-module.routing';
import { CourseNavigationService } from './service/course-navigation.service';

@NgModule({
  imports: [
    CommonModule,
    UserCourseModule,
    UserDashboardModule,
    pgTabsModule,
    pgSwitchModule,
    ProgressModule,
    UserModuleRoutes
  ],
  declarations: [userComponents],
  providers: [FilterService, CourseNavigationService]
})
export class UserModule { }



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user.module.ts